// extracted by mini-css-extract-plugin
module.exports = {"heading":"404Page_heading__Oq6P7"};